export const VOIP_CAMPAIGNS = {
    MONEST: 401,
    SINTONIA: 2145,
    TESTE: 4985,
    MADEIRA_MADEIRA: 6939,
    COLEGIOS: 6649,
    PLATOS: 11015,
    RECEPTIVA: 11394,
};

export const VOIP_CAMPAIGNS_NAMES_MAP = {
    401: 'Monest',
    2145: 'Sintonia',
    4985: 'Teste',
    6939: 'Madeira Madeira',
    6649: 'Colégios',
    11015: 'Platos',
    11394: 'Receptiva',
}
